import client from './internal/httpClient';

// 插件节点：列出所有上报的服务器（IP + 系统 + 明文 key + 归属用户）
export const listNodes = () => client.get('/admin/nodes/list');
